"use client";

import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
import { AuthProvider } from "@/app/providers/AuthProviders";
import { QueryProvider } from "@/app/providers/QueryProvider";
import useRouteTracker from "@/shared/hooks/useRouteTracker";
function AppProviders(t0) {
  const $ = _c(5);
  const {
    initialLoggedIn,
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <QueryProvider>{children}</QueryProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== initialLoggedIn || $[3] !== t1) {
    t2 = <AuthProvider initialLoggedIn={initialLoggedIn}>{t1}</AuthProvider>;
    $[2] = initialLoggedIn;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
export function Providers(t0) {
  const $ = _c(3);
  const {
    initialLoggedIn,
    children
  } = t0;
  useRouteTracker();
  let t1;
  if ($[0] !== children || $[1] !== initialLoggedIn) {
    t1 = <AppProviders initialLoggedIn={initialLoggedIn}>{children}</AppProviders>;
    $[0] = children;
    $[1] = initialLoggedIn;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function PublicProviders(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  useRouteTracker();
  let t1;
  if ($[0] !== children) {
    t1 = <AppProviders initialLoggedIn={false}>{children}</AppProviders>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}